import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import capitalize from 'lodash/capitalize';
import { t } from '../../../helpers/t';

export function ListingOperatingHours() {
  const { operating_hours, is_always_opened } = useSelector((state) => state.listing);

  const day = moment();
  const allDayTime = [day.hour(0).minute(0).format('LT'), day.hour(23).minute(0).format('LT')];

  let operatingHours = [];
  operating_hours.forEach((d) => {
    const operatingHourDay = moment().isoWeekday(d.weekday);
    const label = capitalize(operatingHourDay.format('dddd'));

    operatingHours[d.weekday] = d.is_opened
      ? {
        isOpened: true,
        label: label,
        opensAt: operatingHourDay.hour(d.opens_at).minute(0).format('LT'),
        closesAt: operatingHourDay.hour(d.closes_at).minute(0).format('LT'),
      }
      : { isOpened: false, label: label };
  });

  return (
    <div className="px-4 md:px-0">
      <h2 id="operating_hours" className="text-stone-900 text-xl font-medium mt-0">
        {t('listings.show.sections.availability.subCategories.operatingHours.header')}
      </h2>

      <div className="grid gap-2 grid-flow-col overflow-x-auto">
        {operatingHours.map((day) => (
          <div key={`listing-operating-hour-${day.label}`} className="border-0 border-l-2 border-b border-solid border-stone-100 py-2 flex flex-col items-center justify-center bg-stone-50 rounded min-w-20 hover:bg-stone-100 hover:border-stone-200">
            <div className="mb-2 font-normal text-base text-stone-900">
              {day.label}
            </div>

            {
              is_always_opened
                ? (
                  <div className="text-sm font-extralight text-stone-900">
                    <div>{allDayTime[0]}</div>
                    <div>{allDayTime[1]}</div>
                  </div>
                )
                : (
                  <div className="text-sm font-extralight text-stone-900">
                    {
                      day.isOpened
                        ? (
                          <>
                            <div>{day.opensAt}</div>
                            <div>{day.closesAt}</div>
                          </>
                        )
                        : t('listings.show.sections.availability.subCategories.operatingHours.closed')
                    }
                  </div>
                )
            }
          </div>
        ))}
      </div>
    </div>
  );
}
